import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotificacoesState {

  private requestingNotificacoes = new BehaviorSubject<boolean>(false);
  private notificacoes = new BehaviorSubject<any | null>(null);

  public setRequestingNotificacoes(isLoading: boolean) {
    this.requestingNotificacoes.next(isLoading);
  }

  public setNotificacoes(foiLida: any) {
    this.notificacoes.next(foiLida);
  }

  public getNotificacoes() {
    return this.notificacoes.asObservable();
  }

  public isEmpty() {
    return this.notificacoes.getValue() === null;
  }

}